import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';

class EditUsers extends Component{
    constructor(){
        super();

        this.handleChange = this.handleChange.bind(this);
        this.updateUser = this.updateUser.bind(this);
        this.state = {
            userId:"",
            user :{},
            editUserData :{}
        };
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                    db.on("value",function(data){
                      
                        this.setState({
                            userId:data.key,
                            user:data.val()
                        });
                    }.bind(this));

                var dbEdit = ref.child("users").child(this.props.match.params.uid);
                    dbEdit.on("value",function(data){             
                        this.setState({
                            editUserData : data.val()
                        });

                    }.bind(this));
            }else{
              this.props.history.push("/");
            }

        });       
    } 


    componentWillUnmount(){
        this.listener()
    }

    updateUser(event){
        event.preventDefault();
        const updatedUser = this.state.editUserData;
        ref.child("users").child(`/${this.props.match.params.uid}`).update(updatedUser).then(()=>{
        alert("Users updated successfully")
        
        });
    }
    handleChange(e){
        const updateUser = this.state.editUserData;
        const update ={
            ...updateUser,
            [e.target.name]:e.target.value
        } 
        this.setState({editUserData:update})   
    }
  

    render() {
       
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Edit User" />
                            <div className="block">
                              <form className="form-horizontal form-bordered" ref={(input) => {this.userForm=input}}  onSubmit={this.updateUser}>
                                <div className="form-group">
                                    <label className="col-md-3 control-label" htmlFor="product-id">First Name</label>
                                    <div className="col-md-4">
                                        <input className="form-control"  name="firstname"  value={this.state.editUserData.firstname} type="text" onChange={this.handleChange} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-3 control-label" htmlFor="product-id">Last Name</label>
                                    <div className="col-md-4">
                                        <input className="form-control" name="lastname"  value={this.state.editUserData.lastname} type="text" onChange={this.handleChange} />
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-3 control-label" htmlFor="product-id">Gender</label>
                                    <div className="col-md-4">
                                        <select className="form-control select-chosen"  name="gender" value ={this.state.editUserData.gender} onChange={this.handleChange}>
                                          <option value="Male">Male</option>
                                          <option value="Female">Female</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group">
                                    <label className="col-md-3 control-label" htmlFor="product-id">Role</label>
                                    <div className="col-md-4">
                                        <select className="form-control select-chosen"  name="role" value ={this.state.editUserData.role} onChange={this.handleChange}>
                                          <option value="Admin">Admin</option>
                                          <option value="Salesman">Salesman</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group form-actions">
                                    <div className="col-md-9 col-md-offset-3">
                                        <button type="submit" className="btn btn-sm btn-primary"><i className="fa fa-floppy-o"></i> Update User</button>
                                    </div>
                                </div>
                              </form>

                                
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
            
        );
    }
}

export default  EditUsers;



// WEBPACK FOOTER //
// ./src/components/EditUsers.js